import React from 'react';
import PropTypes from 'prop-types';

export default function UserProfileModal({ user, show, onClose }) {
  if (!show) return null;

  // Format phone number for display
  const formatPhoneNumber = (phoneNumber) => {
    if (!phoneNumber) return 'No phone number added';
    // Remove all non-numeric characters
    const cleaned = phoneNumber.replace(/\D/g, '');
    // Format as (XXX) XXX-XXXX
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return '(' + match[1] + ') ' + match[2] + '-' + match[3];
    }
    return phoneNumber; // Return as-is if it doesn't match the expected format
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50 p-4">
      <div className="bg-white rounded-lg p-6 max-w-sm w-full shadow-lg">
        {/* Header */}
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-xl font-bold text-gray-900">Player Profile</h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-500 focus:outline-none"
          >
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Profile Content */}
        <div className="space-y-4">
          <div>
            <label className="text-sm font-medium text-gray-500">Name</label>
            <p className="text-lg font-semibold text-gray-900">{user.name}</p>
          </div>

          <div>
            <label className="text-sm font-medium text-gray-500">NTRP Rating</label>
            <p className="text-lg font-semibold text-gray-900">{user.skillLevel}</p>
          </div>

          <div>
            <label className="text-sm font-medium text-gray-500">Phone Number</label>
            <p className="text-lg font-semibold text-gray-900">
              {user.phoneNumber ? (
                <a 
                  href={`tel:${user.phoneNumber}`}
                  className="text-blue-600 hover:text-blue-800"
                >
                  {formatPhoneNumber(user.phoneNumber)}
                </a>
              ) : (
                <span className="text-gray-500 italic">No phone number added</span>
              )}
            </p>
          </div>
        </div>

        {/* Footer */}
        <div className="mt-6">
          <button
            onClick={onClose}
            className="w-full py-2 px-4 bg-gray-100 text-gray-700 font-medium rounded-lg hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-300"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

UserProfileModal.propTypes = {
  user: PropTypes.shape({
    name: PropTypes.string.isRequired,
    skillLevel: PropTypes.string.isRequired,
    phoneNumber: PropTypes.string
  }).isRequired,
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
}; 